import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAdminRoleSelector } from '@store/common/selectors';
import WebhooksList from '@components/notification-channel/webhooks/List';

const WebhooksSettings = (homePagePath) => {
  const isAdmin = useSelector(isAdminRoleSelector);

  if (!isAdmin) {
    return <Redirect to={homePagePath} />;
  }

  return <WebhooksList/>;
};

export default WebhooksSettings;
